/**
 * @generated SignedSource<<6e5430a089d093edba117d5d51e43d5d>>
 * @relayHash ba28b9487847ffb32ba7693c26c37aa5
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ba28b9487847ffb32ba7693c26c37aa5

import { ConcreteRequest } from 'relay-runtime';
export type CarePlanTherapy = "NUTRITIONAL_COUNSELLING" | "PHYSIOTHERAPY" | "PSYCHOTHERAPY";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type De_saveCarePlanDataInput = {
  appointmentId: string;
  appointmentLanguage: Language;
  attestationGuardian?: CarePlanAttestationGuardianInput | null;
  careProviderId?: string | null;
  followUp?: CarePlanFollowUpInput | null;
  generalAttestation?: CarePlanGeneralAttestationInput | null;
  keepOriginalAuthor: boolean;
  medications: ReadonlyArray<CarePlanMedicationInput>;
  patient: CarePlanPatientInput;
  patientId: string;
  progressNoteId: string;
  recommendedMedications: ReadonlyArray<CarePlanRecommendedMedicationInput>;
  sickLeave?: CarePlanSickLeaveInput | null;
  therapies: ReadonlyArray<CarePlanTherapy>;
  treatmentPlan: CarePlanTreatmentPlanInput;
};
export type CarePlanAttestationGuardianInput = {
  from: any;
  to: any;
};
export type CarePlanFollowUpInput = {
  date: any;
  slotId: number;
};
export type CarePlanGeneralAttestationInput = {
  name: string;
  subject: string;
};
export type CarePlanMedicationInput = {
  asNeeded: boolean;
  eveningDosage: number;
  morningDosage: number;
  name: string;
  nightDosage: number;
  noonDosage: number;
  usageInstruction?: string | null;
};
export type CarePlanPatientInput = {
  birthDate: any;
  firstName: string;
  lastName: string;
};
export type CarePlanRecommendedMedicationInput = {
  asNeeded: boolean;
  eveningDosage: number;
  morningDosage: number;
  name: string;
  nightDosage: number;
  noonDosage: number;
  usageInstruction?: string | null;
};
export type CarePlanSickLeaveInput = {
  from: any;
  to: any;
};
export type CarePlanTreatmentPlanInput = {
  followUpTreatment: string;
  from: any;
  recommendedTreatment: string;
  title: string;
  to: any;
};
export type deSaveCarePlanDataMutation$variables = {
  connections: ReadonlyArray<string>;
  input: De_saveCarePlanDataInput;
};
export type deSaveCarePlanDataMutation$data = {
  readonly saveCarePlanData: {
    readonly carePlanPreviewOutput: {
      readonly carePlanSummary: {
        readonly concludedAt: string | null;
        readonly concludedBy: string | null;
        readonly createdAt: string;
        readonly createdBy: string;
        readonly fileId: string | null;
        readonly fileMetadata: {
          readonly documentType: string;
          readonly extension: string;
          readonly lengthInKilobytes: number;
        } | null;
        readonly id: string;
        readonly progressNoteId: string;
        readonly signedAt: string | null;
        readonly signedBy: string | null;
        readonly treatmentPlan: {
          readonly followUpTreatment: string;
          readonly from: any;
          readonly recommendedTreatment: string;
          readonly title: string;
          readonly to: any;
        };
        readonly updatedAt: string | null;
        readonly updatedBy: string | null;
      };
      readonly previewMarkdown: string;
      readonly progressNoteId: string;
    } | null;
  };
};
export type deSaveCarePlanDataMutation = {
  response: deSaveCarePlanDataMutation$data;
  variables: deSaveCarePlanDataMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progressNoteId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "CarePlanSummary",
  "kind": "LinkedField",
  "name": "carePlanSummary",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CarePlanTreatmentPlan",
      "kind": "LinkedField",
      "name": "treatmentPlan",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "followUpTreatment",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recommendedTreatment",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "from",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "to",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileId",
      "storageKey": null
    },
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "concludedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "concludedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DocumentFileMetadata",
      "kind": "LinkedField",
      "name": "fileMetadata",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "documentType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "extension",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lengthInKilobytes",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "previewMarkdown",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "deSaveCarePlanDataMutation",
    "selections": [
      {
        "alias": "saveCarePlanData",
        "args": (v2/*:: as any*/),
        "concreteType": "De_saveCarePlanDataPayload",
        "kind": "LinkedField",
        "name": "de_saveCarePlanData",
        "plural": false,
        "selections": [
          {
            "alias": "carePlanPreviewOutput",
            "args": null,
            "concreteType": "de_CarePlanPreviewOutput",
            "kind": "LinkedField",
            "name": "de_CarePlanPreviewOutput",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "deSaveCarePlanDataMutation",
    "selections": [
      {
        "alias": "saveCarePlanData",
        "args": (v2/*:: as any*/),
        "concreteType": "De_saveCarePlanDataPayload",
        "kind": "LinkedField",
        "name": "de_saveCarePlanData",
        "plural": false,
        "selections": [
          {
            "alias": "carePlanPreviewOutput",
            "args": null,
            "concreteType": "de_CarePlanPreviewOutput",
            "kind": "LinkedField",
            "name": "de_CarePlanPreviewOutput",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "prependNode",
                "key": "",
                "kind": "LinkedHandle",
                "name": "carePlanSummary",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  },
                  {
                    "kind": "Literal",
                    "name": "edgeTypeName",
                    "value": "De_carePlanSummaryEdge"
                  }
                ]
              },
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ba28b9487847ffb32ba7693c26c37aa5",
    "metadata": {},
    "name": "deSaveCarePlanDataMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0bd73bc0d7c6798bfe15fc4065fba608";

export default node;
